/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var injectStyle = function injectStyle(style) {
  var styleElement = document.createElement("style");
  var styleSheet = null;
  document.head.appendChild(styleElement);
  styleSheet = styleElement.sheet;
  styleSheet.insertRule(style, styleSheet.cssRules.length);
};

export { injectStyle as default };
//# sourceMappingURL=injectStyle.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/_common/js/utils/injectStyle.js
// module id = null
// module chunks = 